<template>
  <Row style="padding: 20px">
    <Col span="12">
      <p><Icon type="md-alert" />仓库渠道映射列表</p>
    </Col>
    <Col span="12" style="text-align: right">
      <Button type="primary" icon="md-checkbox-outline" @click="action(1)"
        >批量导入</Button
      >
      <Button type="primary" icon="md-cloud-upload" @click="action(1)"
        >数据导出</Button
      >
      <Button type="primary" icon="ios-search" @click="action(3)">查询</Button>
      <Button type="primary" icon="md-sync" @click="action(2)">刷新</Button>
    </Col>
    <Col span="24">
      <Input
        v-model="gradeGroup"
        placeholder="请输入Grade Group"
        class="public-inp"
      />
      <Input
        v-model="gradeCode"
        placeholder="请输入Grade Code"
        class="public-inp"
      />
    </Col>
    <Col span="24">
      <Table
        class="table"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="channelList || []"
      >
        <template slot-scope="{ index }" slot="no">
          <span>{{ index + 1 }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a style="margin-right: 5px" @click="detail(row)">查看</a>
        </template>
      </Table>
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "no",
    width: 80,
  },
  {
    title: "Grade Group",
    key: "gradeGroup",
  },
  {
    title: "Grade Code",
    key: "gradeCode",
  },
  {
    title: "创建时间",
    key: "createTime",
  },
  {
    title: "修改时间",
    key: "updateTime",
  },
  {
    title: "操作",
    slot: "action",
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      gradeGroup: "",
      gradeCode: "",
      channelList: [
        {
          gradeGroup: "测试001",
          gradeCode: "ces",
          createTime: "2021-11-11",
          updateTime: "2021-12-12",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      shopInfoQueryList: "warehouse/getWmsChannelList",
    }),
  },
  watch: {},
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // 查看
    detail(item) {
      this.$router.push({
        path: "sourceEdit",
        query: {
          code: this.params.wmsCode,
        },
      });
    },
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("warehouse/getWmsChannelList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    action(t) {
      switch (t) {
        case 1:
          this.addHandler();
          break;
        case 2:
          this.getList();
          break;
        case 3:
          this.$router.push({
            path: "entry",
          });
          break;
        default:
          this.status = 0;
      }
    },
    addHandler() {
      this.$router.push({
        path: "sourceEdit",
        query: {
          code: this.params.wmsCode,
        },
      });
    },
  },
};
</script>
<style scoped>
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/source.vue